import {noop} from '../helpers'

import type {MouseEventHandler} from 'react'

export interface ScrollToElementOnClickProps <Element extends HTMLElement = HTMLElement>{
  element: string | Element
  callback?: MouseEventHandler<Element>
  preventEvent?: boolean
}

export const scrollToElementOnClick = <Element extends HTMLElement = HTMLElement>({
  element,
  callback = noop,
  preventEvent = false,
}: ScrollToElementOnClickProps<Element>): MouseEventHandler<Element> => (event): void => {
  if (preventEvent) event.preventDefault()

  let node: HTMLElement | null
  if (typeof element === 'string') {
    node = document.getElementById(element)
  } else {
    node = element
  }

  if (!node) return

  const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
  const scrollBehavior: ScrollBehavior = hasReducedMotion.matches ? 'instant' : 'smooth'
  node.scrollIntoView({behavior: scrollBehavior})

  callback(event)
}
